<template>
  <div style="padding: 20px 20px 20px 0">
    <div>
      <!-- 搜索条件 -->
      <el-form :inline="true" :model="selectForm" ref="selectForm">
        <el-form-item label="查询日期：">
          <el-date-picker
            clearable
            size="small"
            v-model="queryDate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getTitle" size="small">查询</el-button>
        </el-form-item>

        <el-form-item>
          <el-upload
            action="/api/admin/energy/upload"
            name="file"
            :show-file-list="false"
            :headers="headers"
            :on-success="success"
          >
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="downloadFile"
            >下载导入模版</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="data" style="width: 100%" border :span-method="objectSpanMethod">
      <el-table-column
        v-for="(val, key) in titleList"
        :prop="key"
        :label="val"
        :key="key"
        align="center"
      ></el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-if="totalNum > 0"
      @size-change="sizeChange"
      @current-change="currentChange"
      :page-sizes="[10, 30, 50, 100, 200]"
      :page-size="selectForm.rows"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titleList: [],
      headers: {
        //请求头
        Authorization: localStorage.access_token,
      },
      queryDate: [],
      data: [], //表格数据
      selectForm: {
        //查询条件
        type: 0,
        roomNum: "",
        accountNumber: null,
        property: null,
        status: null,
        unitPay: "",
        page: 1, //当前页
        rows: 10, //页大小
      },
      titleSelect: {
        startTime: "",
        endTime: "",
      },
      totalNum: 0, //数据总数
    };
  },
  methods: {
    downloadFile() {
      //下载导入模板
      this.$http
        .get(
          `/api/energy/downloadAmmeter`,
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=utf-8",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "公区电表导入模版.xls";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    success(res) {
      if (res.code == 0) {
        this.getAll();
        this.$message.success("导入成功");
      } else {
        this.$message.error("导入失败");
      }
    },
    setMonth() {
      let year = new Date().getFullYear();
      let mon = new Date().getMonth() + 1;
      mon = mon - 1;
      if (mon <= 0) {
        year = year - 1;
        mon = mon + 12;
      }
      if (mon < 10) {
        mon = "0" + mon;
      }
      let queryMonth = year + "-" + mon;
      this.queryDate = [queryMonth, queryMonth];
    },

    getAll() {
      //获取表格数据
      this.$http
        .post(`/api/energy/list`, {
          ...this.selectForm,
          ...this.titleSelect
        })
        .then((res) => {
          if (res.data.data != null) {
            this.data = res.data.data.items;
            this.totalNum = res.data.data.totalNum;
          } else {
            this.data = null;
            this.totalNum = 0;
          }
        });
    },
    query() {
      this.selectForm.roomNum = "";
      this.selectForm.page = 1;
      this.queryDate = [];
      this.getAll();
    },
    sizeChange(size) {
      //页大小被修改
      this.selectForm.rows = size;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      this.selectForm.page = page;
      this.getAll();
    },
    getTitle() {
      if (this.queryDate && this.queryDate.length == 2) {
        this.titleSelect.startTime = this.queryDate[0];
        this.titleSelect.endTime = this.queryDate[1];
      } else {
        this.titleSelect.startTime = "";
        this.titleSelect.endTime = "";
      }
      this.$http.post(`/api/energy/getTitle`, { ...this.titleSelect }).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          this.titleList = res.data.data;
          this.getAll();
        } else {
          this.$message.error("查询失败");
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex <= 2) {
        if (!this.data[rowIndex]) {
          // 1列 1行
          return {
            rowspan: 1,
            colspan: 1,
          };
        }
        if (this.data[rowIndex - 1]) {
          if (
            this.data[rowIndex][column.property] ===
            this.data[rowIndex - 1][column.property]
          ) {
            // 0列 0 行
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
        if (this.data[rowIndex + 1]) {
          if (
            this.data[rowIndex][column.property] ===
            this.data[rowIndex + 1][column.property]
          ) {
            let conutRowSpan = 1;
            let countIndex = 1;
            var len = this.data.length;
            // 往下遍历 重复的列有几个 合并几个
            for (var i = rowIndex; i <= len; i++) {
              // 遍历数组
              if (
                this.data[rowIndex + countIndex] &&
                this.data[rowIndex][column.property] ===
                  this.data[rowIndex + countIndex][column.property]
              ) {
                countIndex += 1;
                conutRowSpan += 1;
              } else {
                break;
              }
            }
            // 2列1行
            return {
              rowspan: conutRowSpan,
              colspan: 1,
            };
          }
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
    },
  },
  created() {
    this.getTitle();
  },
  mounted() {},
};
</script>

<style></style>
